// auth.guard.ts
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { TokenStorageService } from '../services/token-storage.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authSvc = inject<AuthenticationService>(AuthenticationService);
  const tokenSvc = inject<TokenStorageService>(TokenStorageService);
  const router = inject<Router>(Router);

  const allowed = (route.data['roles'] as string[]) || [];

  const isAuth = authSvc.checkUserAuthenticationStatus(); // 🔹 no refresh here
  const role = tokenSvc.currentUserRole;

  if (isAuth && allowed.includes(role)) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });
};
